/* ==========================================================================
   Chouchous inline expanding predictive search
   - expands input on focus (.is-focused)
   - live products from /search/suggest.json
   - total count from /search?...&view=count
   - categories (collections) + brands (vendors) filtered client-side
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('ch-search');
  if (!root) return;

  var SHOP_ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (SHOP_ROOT.charAt(SHOP_ROOT.length - 1) !== '/') SHOP_ROOT += '/';

  var wrapper = document.getElementById('ch-search-wrapper');
  var input = root.querySelector('.ch-search__input');
  var reset = document.getElementById('ch-search-reset');
  var panel = document.getElementById('ch-predictive');
  var catList = document.getElementById('ch-cat-list');
  var catEmpty = document.getElementById('ch-cat-empty');
  var brandList = document.getElementById('ch-brand-list');
  var brandEmpty = document.getElementById('ch-brand-empty');
  var products = document.getElementById('ch-products');
  var message = document.getElementById('ch-message');
  var loading = document.getElementById('ch-loading');
  var countEl = document.getElementById('ch-results-count');
  var labelEl = document.getElementById('ch-results-label');
  var seeAll = document.getElementById('ch-seeall');
  var closeBtn = document.getElementById('ch-close');
  var strings = {
    enterSearch: root.dataset.enterSearch || '',
    noProductsFound: root.dataset.noProductsFound || '',
    productsFoundOne: root.dataset.productsFoundOne || '',
    productsFoundOther: root.dataset.productsFoundOther || ''
  };

  var SIDEBAR_MAX = 7;
  var PRODUCT_LIMIT = 9;
  var DEBOUNCE = 250;

  var categories = readJSON('ch-search-categories');
  var brands = readJSON('ch-search-brands').map(function (b) {
    return { name: b.name, count: b.count, url: vendorUrl(b.name) };
  });

  var timer = null;
  var lastQuery = '';
  var requestToken = 0;

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function normalize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function vendorUrl(name) {
    return SHOP_ROOT + 'collections/vendors?q=' + encodeURIComponent(name);
  }

  function searchUrl(q) {
    return (
      SHOP_ROOT +
      'search?q=' +
      encodeURIComponent(q) +
      '&type=product&options%5Bprefix%5D=last'
    );
  }

  function euro(amount) {
    var n = Number(amount);
    if (isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  // suggest.json returns price as a string of cents (e.g. "2750"); be defensive
  function formatPrice(raw) {
    if (raw == null || raw === '') return '';
    if (typeof raw === 'number') return euro(raw / 100);
    var s = String(raw).trim();
    if (/^\d+$/.test(s)) return euro(parseInt(s, 10) / 100);
    var n = parseFloat(s.replace(',', '.'));
    return isNaN(n) ? '' : euro(n);
  }

  /* ---------- expand / collapse / panel ---------- */
  function expand() {
    root.classList.add('is-focused');
    wrapper.classList.add('focused');
    input.setAttribute('aria-expanded', 'true');
  }

  function showPanel() {
    panel.removeAttribute('hidden');
  }

  function hidePanel() {
    panel.setAttribute('hidden', '');
  }

  function collapse() {
    hidePanel();
    input.setAttribute('aria-expanded', 'false');
    root.classList.remove('is-focused');
    wrapper.classList.remove('focused');
  }

  /* ---------- sidebar rendering ---------- */
  function renderSidebar(list, container, emptyEl, q) {
    var nq = normalize(q);
    var items = list;
    if (nq) {
      items = list.filter(function (it) {
        return normalize(it.title || it.name).indexOf(nq) !== -1;
      });
    }
    items = items
      .slice()
      .sort(function (a, b) {
        return (b.count || 0) - (a.count || 0);
      })
      .slice(0, SIDEBAR_MAX);

    if (!items.length) {
      container.innerHTML = '';
      emptyEl.removeAttribute('hidden');
      return;
    }
    emptyEl.setAttribute('hidden', '');
    container.innerHTML = items
      .map(function (it) {
        var label = escapeHtml(it.title || it.name);
        return (
          '<li class="predictive__menu__li">' +
          '<a class="predictive__menu__link" href="' +
          it.url +
          '" title="' +
          label +
          '">' +
          label +
          '<span class="predictive__menu__count">(' +
          (it.count || 0) +
          ')</span></a></li>'
        );
      })
      .join('');
  }

  /* ---------- product rendering ---------- */
  function renderProducts(list) {
    if (!list || !list.length) {
      products.innerHTML = '';
      return;
    }
    products.innerHTML = list
      .map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var imgTag = img
          ? '<img class="predictive__img" src="' +
            img +
            '" alt="' +
            escapeHtml(p.title) +
            '" loading="lazy">'
          : '';
        var brand = p.vendor
          ? '<p class="predictive__brand">' + escapeHtml(p.vendor) + '</p>'
          : '';
        var price = formatPrice(p.price);
        return (
          '<a class="predictive__prod" role="listitem" href="' +
          p.url +
          '" title="' +
          escapeHtml(p.title) +
          '">' +
          '<span class="predictive__top">' +
          imgTag +
          '</span>' +
          '<strong class="predictive__name">' +
          escapeHtml(p.title) +
          '</strong>' +
          brand +
          (price ? '<span class="predictive__price">' + price + '</span>' : '') +
          '</a>'
        );
      })
      .join('');
  }

  /* ---------- fetching ---------- */
  function fetchProducts(q, token) {
    var url =
      SHOP_ROOT +
      'search/suggest.json?q=' +
      encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' +
      PRODUCT_LIMIT +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor';

    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (token !== requestToken) return null;
        return (
          (data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          []
        );
      })
      .catch(function () {
        return [];
      });
  }

  function fetchCount(q, token) {
    var url =
      SHOP_ROOT +
      'search?q=' +
      encodeURIComponent(q) +
      '&type=product&view=count';
    return fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (txt) {
        if (token !== requestToken) return null;
        var n = parseInt((txt || '').trim(), 10);
        return isNaN(n) ? null : n;
      })
      .catch(function () {
        return null;
      });
  }

  /* ---------- main update ---------- */
  function update(q) {
    var token = ++requestToken;
    var nq = (q || '').trim();

    renderSidebar(categories, catList, catEmpty, nq);
    renderSidebar(brands, brandList, brandEmpty, nq);
    seeAll.setAttribute('href', searchUrl(nq));

    if (nq.length < 1) {
      products.innerHTML = '';
      loading.setAttribute('hidden', '');
      message.removeAttribute('hidden');
      message.textContent = strings.enterSearch;
      countEl.textContent = '';
      labelEl.textContent = '';
      return;
    }

    message.setAttribute('hidden', '');
    loading.removeAttribute('hidden');

    Promise.all([fetchProducts(nq, token), fetchCount(nq, token)]).then(function (res) {
      if (token !== requestToken) return;
      loading.setAttribute('hidden', '');
      var list = res[0] || [];
      var total = res[1];

      renderProducts(list);

      if (total == null) total = list.length;
      countEl.textContent = total;
      labelEl.textContent = total <= 1 ? strings.productsFoundOne : strings.productsFoundOther;

      if (!list.length) {
        message.removeAttribute('hidden');
        message.textContent = strings.noProductsFound;
      } else {
        message.setAttribute('hidden', '');
      }
    });
  }

  function scheduleUpdate() {
    var q = input.value;
    reset.toggleAttribute('hidden', q.length === 0);
    if (q === lastQuery) return;
    lastQuery = q;
    clearTimeout(timer);
    timer = setTimeout(function () {
      update(q);
    }, DEBOUNCE);
  }

  /* ---------- events ---------- */
  // Focus only expands the input; the results panel stays hidden until typing.
  input.addEventListener('focus', function () {
    expand();
    if (input.value.trim()) {
      showPanel();
      update(input.value);
    }
  });

  input.addEventListener('input', function () {
    expand();
    if (input.value.trim()) {
      showPanel();
      scheduleUpdate();
    } else {
      hidePanel();
      lastQuery = '';
      reset.setAttribute('hidden', '');
    }
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      collapse();
      input.blur();
    }
  });

  if (reset) {
    reset.addEventListener('click', function () {
      input.value = '';
      lastQuery = '';
      reset.setAttribute('hidden', '');
      hidePanel();
      input.focus();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      hidePanel();
    });
  }

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) collapse();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') collapse();
  });
})();
